<template>
	<v-row class="login-warper">
		<v-col>
			<v-row justify="center">
				<v-col cols="12">
					<div class="rectangle">
						<v-form
							ref="form"
							@submit.prevent="onSubmit"
						>
							<div color="black">
								<v-row
									align-content="center"
									justify="center"
								>
									<v-col
										md="3"
										cols="12"
									>
										<smart-input
											v-model="form.username"
											outlined
											solo
											rounded
											background-color="#fff"
											:required="true"
											name="login"
											label="שם משתמש"
											type="text"
										/>
									</v-col>
									<v-col
										md="3"
										cols="12"
									>
										<smart-input
											id="password"
											v-model="form.password"
											outlined
											solo
											rounded
											background-color="#fff"
											required
											name="password"
											label="סיסמא"
											type="password"
										/>
									</v-col>
									<v-col
										md="1"
										cols="12"
									>
										<v-btn
											large
											class="mt-2 px-12"
											dark
											rounded
											type="submit"
											color="#ffc20e"
										>
											<span
												style="font-weight: bold; font-size: large"
											>כניסה</span>
										</v-btn>
									</v-col>
									<v-col
										md="1"
										cols="12"
									>
										<v-btn
											v-if="organization.out_register"
											large
											class="mt-2 mr-12 px-12"
											dark
											rounded
											type="link"
											to="/register"
											color="#ffc20e"
										>
											<span
												style="font-weight: bold; font-size: large"
											>הרשמה</span>
										</v-btn>
									</v-col>
								</v-row>
							</div>
						</v-form>
					</div>
				</v-col>
			</v-row>
			<v-row
				align="center"
				justify="center"
			>
				<v-col cols="12">
					<message-box
						v-if="error"
						:message="error"
					/>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import { types } from "src/store/modules/Auth.module";

export default {
	props: {
		source: String,
	},
	data: () => ({
		disabled: false,
		form: {
			username: null,
			password: null,
		},
		error: null,
	}),
	computed: {
		organization () {
			return this.$store.state.CurrentOrg.organization;
		},
	},
	methods: {
		required (v) {
			return [!!v || "שדה חובה"];
		},
		onSubmit () {
			this.disabled = true;
			this.error = null;
			if (this.$refs.form.validate()) {
				this.$store.dispatch(types.LOGIN, this.form).then(
					() => {
						this.disabled = false;
						this.$router.push({ name: "games-page" });
					},
					(error) => {
						this.disabled = false;
						this.error = error.response.data.errors.username[0];
					}
				);
			}
		},
	},
};
</script>

<style scoped>
.rectangle {
  background-color: #2f5dab;
}
</style>
